<form class="flex flex-col gap-4" [formGroup]="form">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Campaign Name</mat-label>
    <input matInput formControlName="name" autofocus />
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>
      Is this promotional marketing that requires Patient opt-out?
    </mat-label>
    <mat-select formControlName="type">
      @for (type of campaignTypeLabels; track type.value) {
        <mat-option [value]="type.value">
          {{ type.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (hasMultiplePractices$ | async) {
    <pr-practice-selector
      label="Practice to send communication on behalf of?"
      subscriptSizing="dynamic"
      [brands]="brands$ | async"
      [practice]="selectedPractice$ | async"
      (practiceSelected)="practiceSelected($event)"
    />
  }
</form>
